// ReSharper disable once UnusedLocalImport
import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { PartBuilder } from './components/partBuilder';
import './App.css';

class App extends Component {
    
    render() {
        return (
            <Container className="pb-container">
                <div className="pb-block">
                    <div className="pb-block_title">Part Builder</div>
                    <div className="pb-block_body">Quickly find the order-able part number with our online part builder.</div>
                </div>
                <PartBuilder />

            </Container>
        );
    }
}

export default App;
